import { render } from "./FormatItalic.vue?vue&type=template&id=638a5103"
import script from "./FormatItalic.vue?vue&type=script&lang=js"
export * from "./FormatItalic.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/FormatItalic.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "638a5103"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('638a5103', __exports__)) {
    api.reload('638a5103', __exports__)
  }
  
  module.hot.accept("./FormatItalic.vue?vue&type=template&id=638a5103", () => {
    api.rerender('638a5103', render)
  })

}


export default __exports__